<section class="user-profile-schools-subpage profile-section"
         [class.mobile]="deviceService.isMobile()"
         [class.tablet]="deviceService.isTablet()">
  <app-title [title]="'user-profile.tab-schools'"></app-title>

  <ng-template [ngIf]="schools.loaded && schools.items.length">
    <ng-template ngFor let-item [ngForOf]="schools.items" let-i="index" [ngForTrackBy]="trackContentByFn">
      <section class="section school-wrap" id="{{item.id}}">
        <app-school-card [school]="item" (prepared)="onSchoolFullPrepared($event)"></app-school-card>
      </section>
    </ng-template>
  </ng-template>
  <ng-template [ngIf]="schools.loaded && !schools.items.length">
    <div class="empty-content">
      <app-empty *ngIf="isMyAccount" [empty]="emptySchoolObj"></app-empty>
    </div>
  </ng-template>
</section>

<app-pagination
  *ngIf="!deviceService.isMobile()"
  [enabled]="schools.loaded"
  [loading]="schools.loading"
  [pagination]="schools.pagination"
  baseUrl=""
  (nextPage)="onPublicationsNextPage()">
</app-pagination>
